import React from 'react';

const MarketPanelTrendingNow = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Trending Now</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="trending-now">
            <thead>
              <tr>
                <th>Icon</th>
                <th>Stock Name</th>
                <th>Stock Insight</th>
                <th>Current Price</th>
                <th>Change</th>
                <th>% Change</th>
                <th>Volume</th>
                <th>Market Cap (₹ Cr)</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.icon || '-'}</td>
                    <td>{item.stock_name || '-'}</td>
                    <td>{item.stock_insight || '-'}</td>
                    <td>{item.current_price || '-'}</td>
                    <td>{item.change || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.market_cap || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelTrendingNow; 